<template>
  <div class="flex">
    <div
      class="flex items-center rounded-full justify-center text-lg font-bold cursor-pointer mb-1"
      @click="openPicker()"
    >
      <span v-if="reaction != null">{{ reaction }}</span
      ><span v-else><i class="fa fa-heart" style="font-size: 1.3rem"></i></span>
    </div>

    <transition name="fade">
      <div
        v-if="pickerOpened"
        class="flex flex-wrap absolute w-full mt-10 bg-gray-200 p-2 text-lg rounded-full"
        style="width: 200px"
      >
        <div class="flex w-full pb-2">
          <!-- <div class="w-2/4">Pick a reaction</div> -->
          <!-- <div
            class="w-2/4 w-6 h-6 close opacity-50 hover:opacity-100 cursor-pointer"
            @click="closePicker()"
          ></div> -->
        </div>

        <div class="w-full flex flex-wrap">
          <div
            v-for="e in emojis"
            :key="e.name"
            @click="emojiPicked(e.emoji, e.name)"
            class="flex-grow cursor-pointer"
          >
            {{ e.emoji }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { events } from "../events";
import vClickOutside from "click-outside-vue3";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    reaction: Object,
    message: Object,
    index: Object,
    feed_id: Object,
    user_id: Object,
  },
  data() {
    return {
      pickerOpened: false,
      emojis: [
        {
          name: ":thumb:",
          emoji: "👍",
        },
        {
          name: ":love:",
          emoji: "😍",
        },
        {
          name: ":heart:",
          emoji: "❤️",
        },

        {
          name: ":crazy:",
          emoji: "🤪",
        },
        {
          name: ":confused:",
          emoji: "😕",
        },
        {
          name: ":laugh:",
          emoji: "😂",
        },
        {
          name: ":wink:",
          emoji: "😉",
        },
        // {
        //   name: ":raising:",
        //   emoji: "🙌",
        // },
      ],
    };
  },
  mounted() {
    var self = this;

    window.HyreadsEvents.on(events.CLOSE_ALL_REACTION_PICKERS, () => {
      self.pickerOpened = false;
    });

    // window.HyreadsEvents.on(events.OPEN_REACTION, () => {
    //   this.openPicker();
    // });
  },
  methods: {
    openPicker() {
      window.HyreadsEvents.emit(events.CLOSE_ALL_REACTION_PICKERS);
      this.pickerOpened = true;
    },
    closePicker() {
      window.HyreadsEvents.emit(events.CLOSE_ALL_REACTION_PICKERS);
    },
    emojiPicked(emoji, name) {
      window.HyreadsEvents.emit(events.REACTION_CHANGED, {
        emoji,
      });

      this.$store.state.feeds[this.index].your_reaction = {
        reaction: emoji,
      };

      console.log("emoji", emoji);

      let formData = new FormData();
      formData.append("feed_id", this.feed_id);
      formData.append("reaction", emoji);
      formData.append("name", name);
      axios
        .post(`${this.$store.state.endpoints.newReaction}`, formData, {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
        })
        .then((response) => {
          this.$store.state.feeds[this.index].reacts =
            response.data.data.reacts;
          this.$store.state.feeds[this.index].likes = response.data.data.likes;
        });

      this.closePicker();
    },
  },
};
</script>

<style scoped>
.close {
  position: absolute;
  right: 0;
}
.close:before,
.close:after {
  position: absolute;
  right: 15px;
  content: " ";
  height: 20px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.absolute {
  top: -65px;
  position: absolute;
  /* right: 0;
  left: 0; */
}

.h-16 {
  height: 6rem;
}

.actions {
  border-radius: 25px;
  background-color: transparent;
  display: block;
  width: 20px;
  position: absolute;
  bottom: -30px;
  right: 0;
}

/* .w-8 {
  width: 1.2rem;
  height: 1.2rem;
  float: right;
  top: -10px;
} */
</style>
